import { FooterComponent } from './footer.component';

export default FooterComponent;
